export default __webpack_public_path__ + "static/media/icon_4.955dd3f3.png";